import { NAVIGATION_KEYS, SUB_NAVIGATION_KEYS } from "../../src/components/templates/Layout/NavBar/types"
import { SESSION_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"
import { WalletStatus } from "../../src/domain/ethereum/Models/WalletState"
import { TransactionType } from "../../src/domain/ethereum/Models/Transaction"

export default {
  kycStatus: {
    title: "Estatus de tu cuenta",
    options: {
      [SESSION_STATUS_ENUM.APPROVED]: "Verificado",
      [SESSION_STATUS_ENUM.IN_REVIEW]: "En revisión",
      [SESSION_STATUS_ENUM.NOT_STARTED]: "No iniciado",
      [SESSION_STATUS_ENUM.IN_PROGRESS]: "En progreso",
      [SESSION_STATUS_ENUM.DECLINED]: "Rechazado",
      [SESSION_STATUS_ENUM.KYC_EXPIRED]: "Expirado",
      [SESSION_STATUS_ENUM.EXPIRED]: "Expirado",
      [SESSION_STATUS_ENUM.ABANDONED]: "Abandonado",
    },
  },
  walletStatus: {
    [WalletStatus.CONNECTED]: "Conectada",
    [WalletStatus.DISCONNECTED]: "Desconectada",
  },
  navigation: {
    [NAVIGATION_KEYS.DASHBOARD]: {
      title: "Inicio",
      description: "Observa las métricas generales del token {{projectToken}} y DEX",
    },
    [NAVIGATION_KEYS.OPERATE]: {
      title: "Operar",
      description: "Empieza por lo más fácil: compra o consigue tokens en nuestro DEX",
      tag: "Nuevo",
      items: {
        [SUB_NAVIGATION_KEYS.BUY]: {
          title: "Comprar",
          description: "Compra tokens {{projectToken}} con tarjeta o transferencia bancaria",
          tag: "Nuevo",
        },
        [SUB_NAVIGATION_KEYS.SWAP]: {
          title: "Intercambio",
          description: "Intercambia distintos tokens entre sí con los mejores precios",
        },
      },
    },
    [NAVIGATION_KEYS.MORE]: {
      title: "Más",
      items: {
        [SUB_NAVIGATION_KEYS.WALLET]: {
          title: "Cartera",
          description: "Visualiza tus posiciones de liquidez tanto en billetera como en contratos",
        },
        [SUB_NAVIGATION_KEYS.DOCS]: {
          title: "Docs",
          description: "Accede a nuestro Whitepaper para comprender en profundidad el protocolo",
        },
        [SUB_NAVIGATION_KEYS.SETTINGS]: {
          title: "Ajustes",
          description: "Selecciona Idioma, Moneda y Modo claro / oscuro",
        },
      },
    },
  },
  modal: {
    error: {
      title: "Error",
      description: "Ocurrió un error al procesar tu solicitud.",
      sendToSupport: "Enviar a soporte",
      sending: "Enviando...",
      reportId: "ID de reporte",
      reportIdDescription:
        "El ID de reporte se utiliza para rastrear el error y se enviará al equipo de soporte. Puedes copiarlo y pegarlo en el canal de soporte de Telegram para obtener ayuda.",
      copyReportId: "Copiar ID de reporte",
      reportIdCopied: "ID de reporte copiado al portapapeles",
    },
  },
  newVersion: {
    message: "Hay una nueva versión disponible. Por favor, actualiza la página.",
    reload: "Actualizar",
  },
  advancedStaking: "Staking",
  back: "Volver",
  logoAlt: "Logo de Antipartido",
  stepProgress: "Paso {{current}}/{{total}}: ",
  buy: "Comprar",
  buyDescription: " Compra tokens tarjeta o transferencia bancaria",
  buyMobileDescription: "Compra tokens {{projectToken}} con tu tarjeta o tranferencia",
  claim: "Reclamar",
  balance: "Balance",
  max: "Max",
  insufficientBalance: "Balance Insuficiente",
  connect: "Conectar",
  connectWallet: "Conecta tu wallet",
  contractAdress: "Dirección del contrato",
  copy: "Copiar",
  copied: "Copiado",
  clean: "Limpiar",
  dashboard: "Inicio",
  dashboardDescription: "Observa las métricas generales del token {{projectToken}} y DEX",
  myVotings: "Mis Votaciones",
  profile: "Mi perfil",
  error: "Error",
  operate: "Operar",
  operateDescription: "Empieza por lo más fácil: compra o consigue tokens en nuestro DEX",
  liquidity: "Liquidez",
  liquidityDescription: "Aporta liquidez y consigue rentabilidad (APR).",
  liquidityMobileDescription: "Gestiona la liquidez y gana incentivos",
  prices: "Precios",
  rewards: "Recompensas",
  pending: "Pendiente",
  token: "Token",
  sendToSupport: "Enviar a soporte",
  settings: "Ajustes",
  settingsDescription: "Selecciona Idioma, Moneda y Modo claro / oscuro",
  swap: "Intercambio",
  swapDescription: "Intercambia distintos tokens entre sí con los mejores precios",
  swapMobileDescription: "Cambia tokens a los mejores precios",
  docs: "Docs",
  more: "Más",
  docsDescription: "Accede a nuestro Whitepaper para comprender en profundidad el protocolo",
  totalEarned: "Total Ganado",
  address: "Address",
  quantity: "Cantidad",
  send: "Enviar",
  noTransactions: "No hay movimientos recientes.",
  disconnect: "Salir",
  switch_chain: "Cambiar Red",
  various: "Varios",
  variousDescription: "Whitepaper, Guías para aprender, ajustes y más",
  guides: "Guías",
  guidesDescription: "Aprende a operar en el DEX fácilmente con nuestras guías",
  dao: "DAO",
  daoDescription: "Participa en las distintas votaciones sobre el ecosistema y el protocolo",
  transactions: {
    title: "Transacciones",
    errorMessage: "No se ha podido completar la transacción. Revisa la dirección o el saldo de tokens disponibles.",
    seeTransaction: "Ver transacción",
    types: {
      [TransactionType.VOTE]: "Gracias por tu voto",
      [TransactionType.VOTE_EDIT]: "Gracias por tu voto",
    },
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Confirmada",
      REVERTED: "Revertida",
    },
  },
  signature: {
    title: "Firma",
    errorMessage: "No se ha podido firmar la transacción. Revisa la dirección o el saldo de tokens disponibles.",
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Confirmada",
      REVERTED: "Revertida",
    },
  },
  viewContract: "Ver contrato",
  viewInExplorer: "Ver en el explorador",
  view: "Ver",
  wallet: "Cartera",
  walletDescription: "Visualiza tus posiciones de liquidez tanto en billetera como en contratos",
  walletMobileDescription: "Visualiza tus posiciones en todos los tokens del DEX",
  walletAdd: "Añadir a wallet",
  yourAccount: "Tu cuenta",
  myHumanWallet: "Mi HumanWallet",
  timeUnits: {
    second: "segundo",
    seconds: "segundos",
    minute: "minuto",
    minutes: "minutos",
    hour: "hora",
    hours: "horas",
    day: "día",
    days: "días",
    week: "semana",
    weeks: "semanas",
    month: "mes",
    months: "meses",
    year: "año",
    years: "años",
    yearFull: "1 año",
    yearsFull: "{{count}} años",
  },
  mint: "Mintear",
  type: "Tipo",
  value: "Valor",
  new: "Nuevo",
  updateVersion: "Hay una actualización disponible, ¿Deseas actualizar?",
  other: "Otro",
  totalDistributed: "Total repartido",
  dailyDistributed: "Hoy se reparten:",
  supply: {
    title: "Suministro de Token",
    max: "Suministro Máximo",
    total: "Suministro Total",
    circulating: "Suministro Circulante",
    burned: "Quemado",
    contracts: "Contratos",
  },
}
